import React, { useEffect, useState } from 'react';
import { useParams, Redirect } from "react-router-dom";
import { Form, Button, Label } from 'reactstrap';
import EventDesc from './EventDesc';
import InputForm from './InputForm';
import ConfirmPage from './ConfirmPage';
import TermsPage from './TermsPage';
import configData from "../config.json";

export function EventPage(props) {

    let { eventCode } = useParams();
    const folderPath = configData.IMAGE_URL + "event/";

    const [form, setForm] = useState({
		'eventCode': eventCode,
        'name': '',
        'enName': '',
        'hkid': '',
        'phone': '',
        'email': '',
        'socialMedia': '',
        'grecaptcha': null,
        'items': [],
        'agree': false
    });

    const [page, setPage] = useState(1);

    const [eventDetail, setEventDetail] = useState({});
    const [noEvent, setNoEvent] = useState(false);
    const [ended, setEnded] = useState(false);

    const [alertMsg, setAlertMsg] = useState('');

    const [completed, setCompleted] = useState(false);

    const [grecaptchaId, setGrecaptchaId] = useState(null);
    const [showGrecaptcha, setShowGrecaptcha] = useState(false);

	const [submitted, setSubmitted] = useState(false);

	const [busy, setBusy] = useState(false);
	const [maintenance, setMaintenance] = useState(false);
	
	
    const formPost = (e) => {
        e.preventDefault();
        setAlertMsg("");
        if (page === 1) {
            if (form.items.length === 0) {
                setAlertMsg("Please select at least 1 style(s)");
                return;
            }
        }

        if (page === 2) {
            setShowGrecaptcha(true);
            if (grecaptchaId === null) {
                var grecaptcha = window.grecaptcha;
                var gid = grecaptcha.render('recaptcha', {
                    'sitekey': '6LcK7joaAAAAAIlhx1jSaAf8lwTLXCioEepnwhr5'
                });
                setGrecaptchaId(gid);
            }
        }

        if (page < 3) {
            setPage(page + 1);
            window.scrollTo(0, 0);
        }

        if (page === 3) {
            if (!form.agree) {
                setAlertMsg("Please click agree");
                return;
            }
            var grecaptcha = window.grecaptcha.getResponse();
            if (grecaptcha.length === 0) {
                setForm({ ...form, 'grecaptcha': '' });
            } else {
				setSubmitted(true);
				
				var postData = { ...form, 'grecaptcha': grecaptcha };
				postData.items = JSON.stringify(postData.items);

                //preview
                fetch(configData.API_URL + 'submitForm', {
				  method: 'POST',
				  headers: {
					'Content-Type': 'application/json',
				  },
				  body: JSON.stringify(postData),
				})
				.then((res) => {
					if (res.ok) {
						window.scrollTo(0, 0);
						setCompleted(true);
					} 
					else 
					{
						return res.json();
					}
				})
				.then((json) => {
					console.log(json);
					if (json === "event end") {
						setEnded(true);
					} else {
						setBusy(true);
					}
				})
				.catch((error) => {
				  setBusy(true);
				});
			
            }
        }
    }

    useEffect(() => {

        window.scrollTo(0, 0);

        var selectedEvent = props.eventDetails.find(d => Object.keys(d)[0] === eventCode);
        if (selectedEvent) {
            if (selectedEvent[eventCode].ended) {
                setEnded(true);
            }
            setEventDetail(selectedEvent[eventCode]);
        } else {
            setNoEvent(true);
        }

    }, []);


    const updateItems = (styleNo, size, loc) => {
        var item = form.items.find(i => i.styleNo === styleNo);
        if (item) {
            item.size = size;
            item.loc = loc;
        } else {
            var items = [...form.items];
            items.push({ styleNo: styleNo, size: size, loc: loc });

            setForm({ ...form, items: items });
        }
    }

    const removeItems = (styleNo) => {
        var item = form.items.find(i => i.styleNo === styleNo);
        if (item) {
            var items = [...form.items];
            items.splice(items.indexOf(item), 1);
            setForm({ ...form, items: items });
        }
    }

    const backPage = () => {
        setShowGrecaptcha(false);
        setPage(page - 1);
    }

    return (
        <div>
            <div className="text-center justify-content-center border-bottom padding-15">
                <div>
                    <h2>BALLOT REGISTRATION</h2>
                    <h2>抽籤登記</h2>
                </div>
            </div>
            <Form onSubmit={formPost}>
                {
                    page === 1 && 
                    <div>
                        <img alt={eventCode} style={{ "width": "100%" }} src={folderPath + eventCode + "/eventImage.jpg"} />
                        <EventDesc {...eventDetail} />
                        <InputForm
                            form={form}
                            setForm={setForm}
                            items={eventDetail.items}
                            locations={eventDetail.locations}
                            eventCode={eventCode}
                            socialMedia={eventDetail.socialMedia}
                            updateItems={updateItems}
                            removeItems={removeItems}
                            />
                    </div>
                }
                {
                    page === 2 && 
                    <div>
                        <ConfirmPage
                            form={form}
                            items={eventDetail.items}
                            locations={eventDetail.locations}
                            eventCode={eventCode}
                            socialMedia={eventDetail.socialMedia}
                        />
                    </div>
                }
                {
                    page === 3 &&
                    <div>
                        <TermsPage {...eventDetail} value={form.agree} onChange={(e) => setForm({ ...form, 'agree': !form.agree })} />
                    </div>
                }

                <Label className={alertMsg ? '' : 'invisible'} style={{ 'color': 'red' }}>{ alertMsg }</Label>
                <div
                    id="recaptcha"
                    className={showGrecaptcha  ? '' : 'invisible'}
                ></div>
                <Label className={form.grecaptcha === '' ? '' : 'invisible'} style={{ 'color': 'red' }}>Please click the recaptcha checkbox</Label>
                <br />

                <div>
                    <Button
                        className={"col-sm-4 offset-sm-1 mt-3 " + (page > 1 ? '' : 'd-none')}
                        color="success" onClick={() => backPage() }>
                        Back / 上一頁
                    </Button>
                    <Button
						disabled={submitted}
                        className={"col-sm-4 mt-3 " + (page === 1 ? ' offset-sm-7 ' : ' offset-sm-2 ')}
                        color="success" >
                        {page === 3 ? 'Submit / 提交' : 'Next / 下一頁'} 
                    </Button>
                </div>
                <br/>
            </Form>
            {
                noEvent && <Redirect to={'/'} />
            }
            {
                completed && <Redirect to={'/event/'+ eventCode+'/complete'} />
            }
            {
                ended && <Redirect to={'/event/' + eventCode + '/end'} />
            }
			{
                busy && <Redirect to={'/busy'} />
            }
			{
                maintenance && <Redirect to={'/maintenance'} />
            }
        </div>
    );
}
